import { createHandler, sleep } from '../utils';
import { TBadgeTemplateFilter } from '@contexts/BadgeContext/types';
import { API_PATH } from '@api/path/path';
import { mockDB } from '../db';

export const getBadgeTemplates = () =>
  createHandler(
    API_PATH.SbtTemplate.getAllSbtTemplateByOffset,
    async (req, res, ctx) => {
      const limit = Number(req.url.searchParams.get('limit')) || 8;
      const requestPageNumber =
        Number(req.url.searchParams.get('requestPageNumber')) || 1;

      const activeType = req.url.searchParams
        .get('activeType')
        ?.toUpperCase() as TBadgeTemplateFilter;

      const search = req.url.searchParams.get('search');

      mockDB.badge.badgeTemplates.set({ activeType, limit, search });

      await sleep(200);
      return res(
        ctx.status(200),
        ctx.json(mockDB.badge.badgeTemplates.get({ requestPageNumber })),
      );
    },
  );

export const updateBadgeTemplate = () =>
  createHandler(
    API_PATH.SbtTemplate.updateSbtTemplate,
    async (req, res, ctx) => {
      const { id } = req.params;

      await sleep(200);
      return res(ctx.status(200), ctx.json({ id }));
    },
  );

export const deleteBadgeTemplate = () =>
  createHandler(
    API_PATH.SbtTemplate.deleteSbtTemplate,
    async (req, res, ctx) => {
      await sleep(200);
      return res(ctx.status(200));
    },
  );

export const createBadgeTemplates = () =>
  createHandler(
    API_PATH.SbtTemplate.createSbtTemplate,
    async (req, res, ctx) => {
      await sleep(200);
      return res(ctx.status(200), ctx.json({ id: '123' }));
    },
  );

export const getAllSbtForIssuer = () =>
  createHandler(API_PATH.SBT.getAllSbtForIssuer, async (req, res, ctx) => {
    const requestPageNumber =
      Number(req.url.searchParams.get('requestPageNumber')) || 1;

    const limit = Number(req.url.searchParams.get('limit')) || 8;

    const sbtStatusType = req.url.searchParams.get('sbtStatusType');

    const search = req.url.searchParams.get('search');

    mockDB.badge.badgeIusseData.set({ sbtStatusType, limit, search });
    return res(
      ctx.status(200),
      ctx.json(mockDB.badge.badgeIusseData.get({ requestPageNumber })),
    );
  });

export const expireBadge = () =>
  createHandler(API_PATH.SBT.expireSbt, async (req, res, ctx) => {
    await sleep(200);

    return res(ctx.status(200));
  });

export const getBadgeStatistics = () =>
  createHandler(API_PATH.SBT.getSbtsStatistics, async (req, res, ctx) => {
    await sleep(200);
    const duration = req.url.searchParams.get('duration');

    mockDB.badge.badgeStatistics.set({ duration });
    return res(ctx.status(200), ctx.json(mockDB.badge.badgeStatistics.get()));
  });

export const dropBadge = () =>
  createHandler(API_PATH.SBT.provideSbt, async (req, res, ctx) => {
    await sleep(200);

    return res(ctx.status(200), ctx.json({ id: 'success' }));
  });

export const getUserBadges = () =>
  createHandler(
    {
      method: 'GET',
      path: '/v1/admin/users/{userId}/sbts',
    },
    async (req, res, ctx) => {
      const requestPageNumber = Number(
        req.url.searchParams.get('requestPageNumber'),
      );
      const limit = Number(req.url.searchParams.get('limit'));
      mockDB.badge.badgeIusseData.set({ limit });
      await sleep(200);

      return res(
        ctx.status(200),
        ctx.json(mockDB.badge.badgeIusseData.get({ requestPageNumber })),
      );
    },
  );

export const getBadgeDetail = () =>
  createHandler(API_PATH.SBT.getSbtById, async (req, res, ctx) => {
    await sleep(200);

    return res(ctx.status(200), ctx.json(mockDB.badge.badgeDetail.get()));
  });

export default [
  getBadgeTemplates(),
  createBadgeTemplates(),
  getAllSbtForIssuer(),
  expireBadge(),
  getBadgeStatistics(),
  dropBadge(),
  getUserBadges(),
  getBadgeDetail(),
  updateBadgeTemplate(),
  deleteBadgeTemplate(),
];
